import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TempestUser, User, UserToCreate, UserToUpdate } from "src/app/auth/model/user";
import { BaseHttpService } from "src/app/shared/services/base.http.service";

@Injectable({
  providedIn: "root",
})
export class UserService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  createUser(data: UserToCreate) {
    return this.http.post(`${this.apiUrl}/api/accounts/admin/register`, data);
  }

  getUser(id: number) {
    return this.http.get<User>(`${this.apiUrl}/api/accounts/${id}`);
  }

  updateUserRole(id: number, role: string) {
    return this.http.put<User>(`${this.apiUrl}/api/accounts/update/${id}/role`, { role });
  }

  updateUser(id: number, user: UserToUpdate) {
    return this.http.put<User>(`${this.apiUrl}/api/accounts/update/${id}`, user);
  }

  deleteUser(id: number) {
    return this.http.delete(`${this.apiUrl}/api/accounts/${id}`);
  }

  getContractUsers(apiKey: string = "") {
    return this.http.get<TempestUser[]>(`${this.apiUrl}/api/accounts/contract-users?apiKey=${apiKey}`);
  }

  deleteInstanceUser(email: string, apiKey: string) {
    return this.http.delete(`${this.apiUrl}/api/accounts/instace-user?email=${email}&apiKey=${apiKey}`);
  }
}
